import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-16-close (1)",
  "use": "icon-icon-16-close (1)-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-16-close (1)\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M0 0h16v16H0z\" /><g fill=\"#4C556C\" fill-rule=\"nonzero\"><path d=\"M12.95 3.05a1 1 0 0 1 0 1.414L4.464 12.95a1 1 0 1 1-1.414-1.414l8.486-8.486a1 1 0 0 1 1.414 0z\" /><path d=\"M12.95 12.95a1 1 0 0 1-1.414 0L3.05 4.464A1 1 0 1 1 4.464 3.05l8.486 8.486a1 1 0 0 1 0 1.414z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol